<template>
	<div v-if="records === false">
		<button v-on:click="load()" :disabled="loading">Load</button>
	</div>
	<Loader v-else-if="loading" />
	<div v-else class="content">
		<table>
			<thead>
				<tr>
					<th>#</th>
					<th>Channel</th>
					<th>Card</th>
					<th>Expiration date</th>
					<th>Default</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="record in records">
					<td>{{ record.id }}</td>
					<td>{{ record.payment_channel.name }}</td>
					<td>
						<CreditCard :number="record.options.number" :type="record.options.type" />
					</td>
					<td>{{ record.options.expiration_date ? record.options.expiration_date.date : '' }}</td>
					<td>
						{{ record.is_default ? 'Default' : '' }}
					</td>
					<td>
						<button
							class="small"
							v-on:click="deleteCard(record.id)"
							:disabled="saving">Delete</button>

						<button
							class="small small-margin-left"
							v-if="!record.is_default"
							v-on:click="setAsDefault(record.id)"
							:disabled="saving">Set as default</button>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="margin-top">
			<button :disabled="saving" v-on:click="updateFromGateway">Refresh from gateway</button>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: [
    'id',
    'autoload'
  ],
  data: () => ({
    loading: false,
    saving: false,
    records: false
  }),
  methods: {

    /**
			 * Load the customer payment methods
			 *
			 * @return void
			 */
    load () {
      Vue.$api.get('/customer/' + this.id + '/payment-methods', {}, {
        loader: toggle => this.loading = toggle,
        callback: data => this.parse(data)
      })
    },

    /**
			 * Parse the received  data
			 *
			 * @param {Object} data
			 * @return void
			 */
    parse (data) {
      this.records = data
    },

    /**
			 * Set the payment method as default
			 *
			 * @param {Number} id
			 * @return void
			 */
    setAsDefault (id) {
      Vue.$api.post('/payment-method/' + id + '/default', {}, {
        loader: toggle => this.saving = toggle,
        callback: () => this.load()
      })
    },

    /**
			 * Delete the specified payment method
			 *
			 * @param {Number} id
			 * @return void
			 */
    deleteCard (id) {
      if (confirm('Are you sure?')) {
        Vue.$api.delete('/customer/' + this.id + '/payment-method/' + id, {}, {
          loader: toggle => this.saving = toggle,
          callback: () => this.load()
        })
      }
    },

    /**
			 * Update payment methods from the gateway
			 *
			 * @return void
			 */
    updateFromGateway () {
      Vue.$api.post('/customer/' + this.id + '/payment-methods/update-from-gateway', {}, {
        loader: toggle => this.saving = toggle,
        callback: () => this.load()
      })
    }

  },
  created () {
    if (this.autoload) {
      this.load()
    }
  }
}
</script>
